// extracted by mini-css-extract-plugin
export default {"content-container":"Reports_content-container__o948U","main-text":"Reports_main-text__P+F9P","link":"Reports_link__JvJU5"};